import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { LocalStorageUtilWrapperService } from 'src/app/services/local-storage-util-wrapper.service';
import { TokenExpiryService } from 'src/app/services/token-expiry.service';

@Component({
  selector: 'app-token-expiry-global-modal',
  templateUrl: './token-expiry-global-modal.component.html',
  styleUrls: ['./token-expiry-global-modal.component.scss'],
})
export class TokenExpiryGlobalModalComponent implements OnInit {
  @ViewChild('vcsAccExpiryAlert', { static: true })
  private vcsAccExpiryAlert: TemplateRef<any>;
  SHOW_TOKEN_STORAGE_KEY = 'SHOW_TOKEN_EXPIRY_FLAG';
  showFlag: boolean = true;
  TEN_DAYS = 10 * 24 * 60 * 60 * 1000;

  constructor(
    private tokenExpiryService: TokenExpiryService,
    private dialogBoxService: NbDialogService,
    private localStorageService: LocalStorageUtilWrapperService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.showFlag =
      Date.now() -
        new Date(
          this.localStorageService.get(this.SHOW_TOKEN_STORAGE_KEY),
        ).getTime() >=
      this.TEN_DAYS;
    if (this.showFlag) {
      this.showVCSTokenExpiryNotice();
    }
  }

  async showVCSTokenExpiryNotice() {
    if (!this.tokenExpiryService?.expiringAccListLoaded) {
      await this.tokenExpiryService.extractExpiringAndExpiredVCSAccounts();
    }
    let inUseExpiredAccounts = this.tokenExpiryService
      ?.getInUseVcsAccounts()
      ?.filter((acc) => acc?.tokenExpiryDetails?.expired);

    if (inUseExpiredAccounts?.length > 0) {
      this.dialogBoxService.open(this.vcsAccExpiryAlert, {
        context: inUseExpiredAccounts,
        closeOnBackdropClick: false,
      });
    }
  }

  navigateToAccountsPage(ref) {
    this.router.navigate(['settings/overlay/organization-accounts']);
    ref?.close();
  }

  snoozeAlert(ref) {
    this.localStorageService.set(this.SHOW_TOKEN_STORAGE_KEY, Date.now());
    ref?.close();
  }
}
